import { Box, Grid, Paper} from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getVendorPayouts } from "services/vendorDashboard";
import '@inovua/reactdatagrid-community/index.css'
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { getDbFormat } from "utils/common";

export default function VendorPayouts({pageFilters}) {
  
  const [, setGridRef] = useState(null);
  
  const { enqueueSnackbar } = useSnackbar();
  const [payouts, setPayouts] = useState([]);
  const gridStyle = useMemo(() => ({ height:( payouts.length > 0 ? payouts.length * 56.2 :  500), width: 'auto', maxHeight: '70vh'}), [payouts]);

  const columns = useMemo(() => ([
    { name: 'bankName', header: 'Bank', sortable: false, defaultFlex: 1, minWidth: 120},
    { name: 'accountNumber', header: 'Account No', sortable: false, defaultFlex: 1, minWidth: 160},
    { name: 'amount', header: 'Amount', sortable: false, defaultFlex: 1, minWidth: 120},
    { name: 'method', header: 'Method', sortable: false, defaultFlex: 1, minWidth: 120},
    { name: 'referenceNumber', header: 'Reference Number', sortable: false, defaultFlex: 1, minWidth: 220},
    { name: 'createdOn', header: 'Date', sortable: false, defaultFlex: 1, minWidth: 120},
  ]), []);

  const getPayouts = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };

    getVendorPayouts(data).then(({response, error}) => {
      if(response){
        setPayouts(response);
      } else {
        setPayouts([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getPayouts(pageFilters);
    }
  }, [getPayouts, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} lg={12} >
              <Box component="div" sx={{  maxHeight: 720, width: '100%' }}>
                <ReactDataGrid
                  handle={setGridRef}
                  idProperty="id"
                  style={gridStyle}
                  columns={columns}
                  dataSource={payouts}
                  rowHeight={null} 
                  minRowHeight={50}
                  showColumnMenuTool={false} 
                />
              </Box>
            </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
